interface AnalyticsIconProps {
  width?: string;
  height?: string;
  fill?: string;
  strokeColor?: string;
}

const AnalyticsIcon = (props: AnalyticsIconProps) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill={props?.fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_13285_48660)">
        <path
          d="M20.5186 19.3047H27.4502C27.4763 19.3047 27.4966 19.3244 27.499 19.3496L27.4922 19.377L27.4893 19.417C27.3582 21.2523 26.6314 22.9209 25.499 24.2354L25.4795 24.2578L25.4629 24.2822C25.454 24.2954 25.4392 24.3046 25.4209 24.3047C25.4064 24.3047 25.3926 24.2984 25.3838 24.2891L25.3779 24.2822L20.4863 19.3906C20.4721 19.3766 20.4688 19.3634 20.4688 19.3545C20.4688 19.3278 20.4918 19.3047 20.5186 19.3047Z"
          stroke="#999999"
        />
        <path
          d="M18.4189 9.34082C22.581 9.60943 25.9075 12.9376 26.1758 17.0977C26.1733 17.125 26.1521 17.1445 26.1279 17.1445H18.4229C18.3995 17.1445 18.375 17.1249 18.375 17.0928V9.38965C18.375 9.36553 18.393 9.34433 18.4189 9.34082Z"
          stroke="#999999"
        />
        <path
          d="M16.2754 10.0381C16.3007 10.0396 16.3203 10.0593 16.3203 10.085L16.3223 18.1123C16.3223 18.391 16.4307 18.6543 16.6191 18.8467L16.623 18.8496L22.3027 24.5293V24.5303C22.313 24.5408 22.3183 24.5531 22.3184 24.5654C22.3184 24.5739 22.316 24.5807 22.3135 24.5859C22.3108 24.5914 22.3068 24.5963 22.3018 24.6006L22.2939 24.6074C20.8305 25.8871 18.9171 26.6621 16.8203 26.6621C12.2255 26.6621 8.5 22.935 8.5 18.3398C8.50013 13.9289 11.9343 10.3173 16.2754 10.0381Z"
          stroke="#999999"
        />
      </g>
      <defs>
        <clipPath id="clip0_13285_48660">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AnalyticsIcon;
